<template>
  <VTBaseTemplate>
    <b-modal
        id="deactivate-account-modal"
        v-model="deactivateAccountModalShow"
        centered
        scrollable
        hide-footer
        hide-header-close
        no-close-on-backdrop
        no-close-on-esc
        title="Account Deactivation"
        :header-bg-variant="'warning'"
        :header-text-variant="'light'">
        <span v-html="err_msg"></span>
        <b-button class="mt-3" @click="hideDeactivateAccountModal()" block>Cancel</b-button>
        <b-button class="mt-3" variant="danger" @click="deactivateAccount(); hideDeactivateAccountModal();" block>Deactivate Account</b-button>
      </b-modal>
    <div class="row">
      <div class="col-sm-3 ml-4 mr-4">
        <h4>My Profile</h4>
        <b-card
          img-src="https://avataaars.io/?avatarStyle=Transparent&topType=ShortHairShortCurly&accessoriesType=Prescription02&hairColor=Black&facialHairType=Blank&clotheType=Hoodie&clotheColor=White&eyeType=Default&eyebrowType=DefaultNatural&mouthType=Default&skinColor=Light"
          img-alt
          img-top
          img-height="150"
          img-width="150"
          tag="article"
          class="mb-2"
        >
          <b-list-group flush>
            <b-list-group-item>
              <strong>Username:</strong>
              {{user.username}}
            </b-list-group-item>
            <b-list-group-item>
              <strong>Email:</strong>
              {{user.email}}
            </b-list-group-item>
            <b-list-group-item>
              <strong>Password:</strong>
              <b-button :to="{name: 'change-password'}" variant="primary ml-2" style="color: white!important;">Change</b-button>
            </b-list-group-item>
            <b-list-group-item>
              <strong>Admin:</strong>
              {{user.is_staff ? 'Yes' : 'No'}}
            </b-list-group-item>
            <b-list-group-item>
              <strong>Groups:</strong>
              {{ myGroups.length > 0 ? myGroups.join(", ") : 'None'}}
            </b-list-group-item>
            <b-list-group-item>
              <strong>Deactivate Account:</strong>
              <b-button @click="showDeactivateAccountModal()" variant="danger ml-2" style="color: white!important;">Deactivate</b-button>
            </b-list-group-item>
          </b-list-group>
        </b-card>
      </div>
      <div id="content-div" class="col-sm-8 flex-row content">
        <h4>My Datasets</h4>
        <b-tabs content-class="mt-3" justified>
          <b-tab title="VecTraits Datasets" :title-item-class="'tab-title-class'" active>
            <UserDatasetTable :tableType="'vectraits'"/>
          </b-tab>
          <b-tab title="VecDyn Datasets" :title-item-class="'tab-title-class'">
            <!-- TODO: Uncomment the line below & delete the h5 tag when the corresponding API View is updated as per the new Vecdyn changes -->
            <!-- <UserDatasetTable :tableType="'vecdyn'"/> -->
            <h5>Coming soon...</h5>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </VTBaseTemplate>
</template>

<script>
import HandleErrors from "@/utilities/handle-errors";

import BaseDialogMixin from "@/components/mixins/BaseDialogMixin.vue";
import BaseAlertMixin from "@/components/mixins/BaseAlertMixin.vue";
import VTBaseTemplate from "@/layouts/VTBaseTemplate.vue";

import { mapActions, mapState } from "vuex";
import { HTTP } from "@/utilities/http-common";
import UserDatasetTable from "./UserDatasetTable.vue";

export default {
  mixins: [BaseDialogMixin, BaseAlertMixin, VTBaseTemplate],
  computed: {
    ...mapState("user", ["user", "myGroups"])
  },
  created(){
    document.title = "User Profile";
    this.fieldArray[0] = "";
    this.operatorArray[0] = "";
  },
  components: {
    VTBaseTemplate,
    UserDatasetTable
},
  mounted: function() {
    let that = this;

    if (!that.user.email) {
      that.showLoadingDialog("Fetching information!");

      that
        .getUser()
        .then(response => {
          that.setUser(response.data);
        })
        .catch(error => {
          HandleErrors.HandleErrors(error);
        })
        .finally(() => {
          that.hideLoadingDialog();
        });
    }

    that
      .getMyGroups()
      .then(response => {
        that.setMyGroups(response.data);
      })
      .catch(error => {
        HandleErrors.HandleErrors(error);
      });
  },
  data(){
    return {
      err_msg: "", // If any errors during a call to the backend, that error content will end up in this variable and be displayed on the modal.
      route_err: "", // If there were errors on the $route, they end up in this variable. There were a few issues before when there would be an error output to the console but it would work just fine. This is a hackey way to do things but it worked.
      apiErrModalShow: false, // show error modal or not
      deactivateAccountModalShow: false,
    }
  },
  methods: {
    ...mapActions("user", ["setUser", "getUser", "getMyGroups", "setMyGroups"]),
    ...mapActions(["clearAuthorizationToken"]),
    showDeactivateAccountModal: function(){
      this.deactivateAccountModalShow = true;
      this.err_msg = "Are you sure you want to deactivate your account? This action is irreversiable. To reactivate the account, you will need to contact help@vectorbyte.org."
    },
    hideDeactivateAccountModal: function(){
      this.deactivateAccountModalShow = false;
      this.err_msg = ""
    },
    deactivateAccount: function(){
      HTTP.put(`/api/user/deactivate/`)
        .then(response => { 
          this.clearAuthorizationToken();
          this.setUser({});
          this.setMyGroups([]);

          this.$notify({
            text: response.data.message,
            duration: 10000,
            type: "success"
          });
      })
      .catch(error => {
          this.err_msg = HandleErrors.HandleErrors(error);
          this.apiErrModalShow = true;
      });
    }
  }
};
</script>

<style>
.tab-title-class{
  font-size: 15px !important;
}
</style>